import React, { useState, useEffect, useRef } from "react";
import CheckoutHeader from "../../../components/checkout/CheckoutHeader";
import Box from "@mui/system/Box";
import styles from "./style.module.css";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import LeftSidebar from "../../../components/sidebars/LeftSidebar";
import ProductImage from "../../../images/product.png";
import { UserCommonStyles } from "../../../styles/CommonStyles";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RoutingLinks, Type } from "../../../utils/constants";
import { isEmpty } from "../../../utils/helper";
import { yupResolver } from "@hookform/resolvers/yup";
import { shippingAddressPageField } from "../../../utils/validationSchema";
import { shippingAddress } from "../../../interfaceModules/IUserInterface";
import SocialIconSection from "../../../components/sidebars/SocialIconSection";
import { useForm } from "react-hook-form";

const ShippingAddress = () => {
  const commonStyle = UserCommonStyles();
  const history = useHistory();
  const { t: translation } = useTranslation();

  const [checkoutData, setCheckoutData] = useState<any>(
    JSON.parse(localStorage.getItem(Type?.shoppingCartCheckout) || "{}")
  );
  const [isDifferentAddress, setIsDifferentAddress] = useState<boolean>(
    checkoutData?.different_address || false
  );
  const [timeOutState, setTimeOutState] = useState(null);
  const [loactionerr, setlocationerr] = useState(false);
  const [locationPredictions, setLocationPredictions] = useState({
    predictions: [],
    location: checkoutData?.shipping_address?.city || "",
    selectedLocation: checkoutData?.shipping_address?.city || "",
  });

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setLocationPredictions((prevState) => ({
            ...prevState,
            predictions: [],
          }));
        }
      }

      /**
       * Bind the event listener
       */
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        /**
         * Unbind the event listener on clean up
         */
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<shippingAddress>({
    resolver: yupResolver(shippingAddressPageField(isDifferentAddress)),
  });

  /**
   * Autocomplete search
   * @param text
   * @returns
   */
  const googleAutocomplete = async (text: string) => {
    if (isEmpty(text)) {
      setLocationPredictions((prevState) => ({
        ...prevState,
        predictions: [],
      }));
      return null;
    }
    if (!text) {
      return translation("valid_text");
    }
    if (typeof window === "undefined") {
      return translation("valid_window");
    }

    try {
      let result;
      let autocompleteService =
        await new google.maps.places.AutocompleteService();
      result = await autocompleteService.getPlacePredictions(
        { input: text },
        result
      );
      return result;
    } catch (e) {
      return e;
    }
  };

  /**
   * Select location
   * @param event
   */
  const selectLocation = async (event?: React.SyntheticEvent | Event) => {
    const target = event.target as HTMLInputElement;
    setLocationPredictions((prevState) => ({
      ...prevState,
      location: target.value,
    }));
    if (timeOutState) {
      clearInterval(timeOutState);
    }

    let result = setTimeout(async () => {
      let results = await googleAutocomplete(target.value);
      if (results) {
        setLocationPredictions((prevState) => ({
          ...prevState,
          predictions: results?.predictions,
        }));
      }
    }, 800);

    setTimeOutState(result);
  };

  /**
   * on Place selected by placeId
   * @param placeId
   * @param placeDescription
   * @param event
   * @returns
   */
  const onPlaceSelected = async (
    placeId: string,
    placeDescription: string,
    event: React.SyntheticEvent
  ) => {
    setlocationerr(false);

    event.preventDefault();
    // const response: any = await dispatch(GooglePlacesDetail(placeId));
    // if (!response || !response.result) {
    //     return;
    // }
    setLocationPredictions({
      predictions: [],
      location: placeDescription,
      selectedLocation: placeDescription
    });
  };

  const onSubmit = (data: any) => {
      if (locationPredictions.selectedLocation === "") {
        setlocationerr(true);
    } else {
        data.city = locationPredictions.selectedLocation;
        const data2 = {
            ...checkoutData,
            shipping_address: data,
            different_address: isDifferentAddress,
          };
          localStorage.setItem(Type?.shoppingCartCheckout, JSON.stringify(data2));
          history.push(RoutingLinks.checkout_step3_payment);
          reset({});
    };
  };

  return (
    <Box>
      <Box className={styles.windowColor}>
        <Grid container>
          <Grid item md={3}>
            <LeftSidebar />
            {/* <SocialIconSection /> */}
          </Grid>
          <Grid item md={9}>
            <Typography mt={5} ml={2} mb={3} className={styles.heading}>
              Shipping Address
            </Typography>
            <Box className={styles.subContainer}>
              <CheckoutHeader step2={true} step3={false} />
              <div className={styles.shipping_address_form}>
                <p className={styles.heading2}>Shipping Address</p>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid container spacing={2}>
                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {"First Name"}
                        </Typography>
                        <TextField
                          {...register("firstname")}
                          placeholder={"First Name"}
                          variant="outlined"
                          className={commonStyle.w100}
                          defaultValue={
                            checkoutData?.shipping_address?.firstname || ""
                          }
                        />
                        {errors && errors?.firstname && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.firstname?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {"Last Name"}
                        </Typography>
                        <TextField
                          placeholder={"Last Name"}
                          {...register("lastname")}
                          variant="outlined"
                          className={commonStyle.w100}
                          defaultValue={
                            checkoutData?.shipping_address?.lastname || ""
                          }
                        />
                        {errors && errors?.lastname && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.lastname?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>
                    <Grid item md={12}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {"Address"}
                        </Typography>
                        <TextField
                          placeholder={"Address"}
                          {...register("address")}
                          variant="outlined"
                          className={commonStyle.w100}
                          defaultValue={
                            checkoutData?.shipping_address?.address || ""
                          }
                        />
                        {errors && errors.address && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.address?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>
                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {"Email"}
                        </Typography>
                        <TextField
                          placeholder={"info@domain.com"}
                          type="email"
                          {...register("email")}
                          variant="outlined"
                          className={commonStyle.w100}
                          defaultValue={
                            checkoutData?.shipping_address?.email || ""
                          }
                        />
                        {errors && errors.email && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.email?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {"Phone Number"}
                        </Typography>
                        <TextField
                          type="number"
                          placeholder={"5555-55-555"}
                          {...register("phone_number")}
                          variant="outlined"
                          className={commonStyle.w100}
                          // inputProps={{ maxLength: 10 }}
                          defaultValue={
                            checkoutData?.shipping_address?.phone_number || ""
                          }
                        />
                        {errors && errors.phone_number && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.phone_number?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {"City"}
                        </Typography>
                        <TextField
                          {...register("city")}
                          variant="outlined"
                          className={commonStyle.w100}
                          autoComplete="off"
                          onChange={selectLocation}
                          value={locationPredictions.location ? locationPredictions.location : ""}
                        //   defaultValue={locationPredictions.location ? locationPredictions.location : checkoutData?.shipping_address?.city}
                        />
                        {locationPredictions.predictions.length !== 0 && (
                          <div className="search-drop-list" ref={wrapperRef}>
                            <ul className={commonStyle.searchCommonList}>
                              {locationPredictions.predictions.map(
                                (prediction) => (
                                  <li
                                    key={prediction?.place_id}
                                    onClick={(e) => {
                                        setlocationerr(false);
                                        setLocationPredictions({
                                            predictions: [],
                                            location: prediction?.description,
                                            selectedLocation: prediction?.description
                                          })
                                    }}
                                  >
                                    {prediction?.description ||
                                      translation("not_found")}
                                  </li>
                                )
                              )}
                            </ul>
                          </div>
                        )}
                        {errors && errors.city && (
                                <span className={commonStyle.errorMsg}>
                                     {errors?.city?.message}
                                </span>
                            )} 
                            {loactionerr && (
                                <span className={commonStyle.errorMsg}>
                                    {"Please select a valid location"}
                                </span>
                            )}
                      </Box>
                    </Grid>

                    {/* <Grid item md={6}>
                                            <Box className={commonStyle.commonInput}>
                                                <Typography className={commonStyle.labelCommonInput}>
                                                    {"Country"}
                                                </Typography>
                                                <TextField
                                                    {...register("country")}
                                                    variant="outlined"
                                                    className={commonStyle.w100}
                                                    defaultValue={checkoutData?.shipping_address?.country || ""}
                                                />
                                                {errors && errors.country && (
                                                    <span className={commonStyle.errorMsg}>
                                                        {errors?.country?.message}
                                                    </span>
                                                )}
                                            </Box>
                                        </Grid> */}

                    {/* <Grid item md={6}>
                                            <Box className={commonStyle.commonInput}>
                                                <Typography className={commonStyle.labelCommonInput}>
                                                    {"PostCode"}
                                                </Typography>
                                                <TextField
                                                    type='number'
                                                    {...register("post_code")}
                                                    variant="outlined"
                                                    className={commonStyle.w100}
                                                    defaultValue={checkoutData?.shipping_address?.post_code || ""}
                                                />
                                                {errors && errors.post_code && (
                                                    <span className={commonStyle.errorMsg}>
                                                        {errors?.post_code?.message}
                                                    </span>
                                                )}
                                            </Box>
                                        </Grid> */}

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {"Zip"}
                        </Typography>
                        <TextField
                          type="number"
                          {...register("zip")}
                          variant="outlined"
                          className={commonStyle.w100}
                          defaultValue={
                            checkoutData?.shipping_address?.zip || ""
                          }
                        />
                        {errors && errors.zip && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.zip?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>

                    <Grid item md={12}>
                      <div>
                        <p className={styles.heading2}>Billing Address</p>
                        <p className={styles.heading3}>
                          {"(Same as shipping address)"}
                        </p>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={(e: any) =>
                                setIsDifferentAddress(e?.target?.checked)
                              }
                              checked={isDifferentAddress}
                            />
                          }
                          label="Bill to different address"
                        />
                      </div>
                    </Grid>

                    {isDifferentAddress ? (
                      <Grid item md={12} mt={3}>
                        <Box className={commonStyle.commonInput}>
                          <Typography className={commonStyle.labelCommonInput}>
                            {"Different Address"}
                          </Typography>
                          <TextField
                            placeholder={"Address to ship your product"}
                            {...register("diff_address")}
                            variant="outlined"
                            className={commonStyle.w100}
                            defaultValue={
                              checkoutData?.shipping_address?.diff_address || ""
                            }
                          />
                          {errors && errors.diff_address && (
                            <span className={commonStyle.errorMsg}>
                              {errors?.diff_address?.message}
                            </span>
                          )}
                        </Box>
                      </Grid>
                    ) : null}

                    <Grid item md={12}>
                      <Box
                        style={{
                          paddingRight: "30px",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <div style={{ width: "50%" }}>
                          <p className={styles.summeryHeading}>Order summary</p>
                          <div>
                            <div className={styles.summary_Detail_Container}>
                              <p className={styles.title}>Subtotal</p>
                              <p className={styles.value}>
                                {checkoutData?.subtotal
                                  ? `$${checkoutData?.subtotal.toFixed(2)}`
                                  : "$0.00"}
                              </p>
                            </div>
                            <div className={styles.summary_Detail_Container}>
                              <p className={styles.title}>Tax 7%</p>
                              <p className={styles.value}>
                                {checkoutData?.subtotal
                                  ? `$${checkoutData?.tax.toFixed(2)}`
                                  : "$0.00"}
                              </p>
                            </div>
                            <div className={styles.summary_Detail_Container}>
                              <p className={styles.title}>Delivery</p>
                              <p className={styles.value}>
                                {checkoutData?.deliveryRate
                                  ? `$${checkoutData?.deliveryRate.toFixed(2)}`
                                  : "$0.00"}
                              </p>
                            </div>
                          </div>
                          <div className={styles.borderBottom}></div>
                          <div className={styles.summary_Detail_Container}>
                            <p className={styles.total}>Total</p>
                            <p className={styles.price}>
                              {checkoutData?.subtotal && checkoutData?.tax && checkoutData?.deliveryRate
                                ? `$${(
                                    checkoutData?.subtotal +
                                    checkoutData?.tax +
                                    checkoutData?.deliveryRate
                                  ).toFixed(2)}`
                                : "$0.00"}
                            </p>
                          </div>
                          <Box className={` ${commonStyle.blueBtn} `}>
                            <Button
                              fullWidth
                              disabled={!checkoutData}
                              style={{
                                fontFamily: "Roboto",
                                fontWeight: "400",
                                fontSize: "20px",
                                alignItems: "center",
                                color: "#fff",
                              }}
                              onClick={handleSubmit(onSubmit)}
                            >
                              {translation("continue")}
                            </Button>
                          </Box>
                        </div>
                      </Box>
                    </Grid>
                  </Grid>
                </form>
              </div>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ShippingAddress;
